import { effects } from 'redux-saga'

import { CHANGE_PASSWORD, UPDATE_PASSWORD } from '../../../modules/service/changePassword'

import change from './change'
import zxcvbn from './zxcvbn'

export default function* changePassword(invocation) {
  yield [
    effects.takeEvery(CHANGE_PASSWORD, change, invocation),
    effects.takeEvery(UPDATE_PASSWORD, zxcvbn),
  ]
}

export const sagas = {
  change,
  zxcvbn,
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/service/changePassword/index.js